import client from "apis/config";

export const getNewAccountsRequestApi = async (page = 1, limit = 10, search = '') => {
  return await client.get(`dashBoard/accounts?page=${page}&search=${search}&limit=${limit}`);
};

export const updateAuctionActionApi = async (paylaod) => {
  return await client.put(`dashBoard/accounts/action`, paylaod);
};
